












































































import { Component, Emit, Ref, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import { Col } from '@/components/molecules/DataTable'
import {
  AlertMessage,
  defaultSystemCodeArea,
  ErrorMessage,
  jobApi,
  SystemCodeArea,
  systemCodeAreaApi
} from '@/api'
import {
  alertStore,
  dataStore,
  modalErrorStore,
  modalJobListStore
} from '@/store'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { AtomTextField } from '@/components/atoms'

interface FilterCondition {
  code: string
  name: string
}

const defaultFilterCondition = (): FilterCondition => ({
  code: '',
  name: ''
})

@Component({
  components: {
    ModalFooter,
    DataTable
  }
})
export default class ModalCodeArea extends ModalComponentBaseVue {
  @Ref()
  codeTextField!: AtomTextField

  @Ref()
  nameTextField!: AtomTextField

  dialog: boolean = false

  tableBodyHeight: number = 0

  items: SystemCodeArea[] = []

  selected: SystemCodeArea = defaultSystemCodeArea()

  filterCondition: FilterCondition = defaultFilterCondition()

  get codeMask(): string {
    return 'X'.repeat(6)
  }

  get cols(): Col[] {
    return [
      {
        width: 26,
        items: [
          {
            name: 'radio',
            align: 'center'
          }
        ]
      },
      {
        width: 50,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: 80,
        resizable: true,
        items: [
          {
            name: 'code',
            headerText: 'code'
          }
        ]
      },
      {
        width: '70',
        resizable: true,
        items: [
          {
            name: 'name',
            headerText: '正式形'
          }
        ]
      },
      {
        width: '30',
        resizable: true,
        items: [
          {
            name: 'shortName',
            headerText: '省略形'
          }
        ]
      }
    ]
  }

  get filteredItems(): SystemCodeArea[] {
    const codeRegExp = new RegExp(`^${this.filterCondition.code}`)
    const nameRegExp = new RegExp(`${this.filterCondition.name}`)

    return this.items.filter(
      item =>
        (this.filterCondition.code === '' || item.code.match(codeRegExp)) &&
        (this.filterCondition.name === '' ||
          item.name.match(nameRegExp) ||
          item.shortName.match(nameRegExp))
    )
  }

  @Watch('filteredItems')
  onFiltered(newVal: SystemCodeArea[]): void {
    if (
      newVal.every(item => item.code !== this.selected.code) &&
      newVal.length > 0
    ) {
      this.selected = newVal[0]
    } else if (newVal.length === 0) {
      this.selected = defaultSystemCodeArea()
    }
  }

  @Watch('dialog')
  onShowChanged(val: boolean) {
    if (val) {
      this.opened()
    } else {
      this.closed()
    }
  }

  mounted() {
    this.debug('mounted()')
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy() {
    this.debug('beforeDestroy()')
    window.removeEventListener('resize', this.onResize)
  }

  open(): void {
    this.dialog = true
    this.$nextTick(() => {
      this.calculateTableHeight()
      setTimeout(this.focus)
    })
  }

  focus(): void {
    if (dataStore.systemCodeDialogInitialFocusName) {
      this.nameTextField.atomTextField.focus()
    } else {
      this.codeTextField.atomTextField.focus()
    }
  }

  close(): void {
    this.dialog = false
    this.filterCondition = defaultFilterCondition()
  }

  async fetchAll() {
    try {
      this.items = await systemCodeAreaApi.getAllSystemCodeArea()
      if (this.items.length > 0) {
        this.selected = this.items[0]
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onClickOk(): void {
    this.$emit('ok', this.selected)
    this.close()
  }

  onClickCancel(): void {
    this.$emit('cancel')
    this.close()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-code-area')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  onRowClick(index: number): void {
    this.selected = this.filteredItems[index]
  }

  onRowDblclick(): void {
    this.onClickOk()
  }

  async downloadExcel() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const jobId = await jobApi.createSystemCodeAreaList()

      await modalJobListStore.newJobId(jobId)
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  @Emit('opened')
  opened(): void {
    this.fetchAll()
  }

  @Emit('closed')
  closed(): void {
    this.items = []
  }
}
